'use client';

import { useState } from 'react';
import {
  ArrowLeft,
  LayoutDashboard,
  UserPlus,
  Target,
  Users,
  Calendar,
} from 'lucide-react';
import { CRMDashboard } from './components/CRMDashboard';
import { LeadListPage } from './components/LeadList';
import { OpportunityListPage } from './components/OpportunityList';
import { CustomerListPage } from './components/CustomerList';
import { ActivityListPage } from './components/ActivityList';

export type CRMPage =
  | 'dashboard'
  | 'leads'
  | 'opportunities'
  | 'customers'
  | 'activities';

interface CRMModuleProps {
  onBack?: () => void;
}

const menuItems: { id: CRMPage; label: string; icon: typeof LayoutDashboard }[] = [
  { id: 'dashboard', label: '대시보드', icon: LayoutDashboard },
  { id: 'leads', label: '리드', icon: UserPlus },
  { id: 'opportunities', label: '영업기회', icon: Target },
  { id: 'customers', label: '고객', icon: Users },
  { id: 'activities', label: '활동', icon: Calendar },
];

export function CRMModule({ onBack }: CRMModuleProps) {
  const [currentPage, setCurrentPage] = useState<CRMPage>('dashboard');

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <CRMDashboard onNavigate={setCurrentPage} />;
      case 'leads':
        return <LeadListPage />;
      case 'opportunities':
        return <OpportunityListPage />;
      case 'customers':
        return <CustomerListPage />;
      case 'activities':
        return <ActivityListPage />;
      default:
        return <CRMDashboard onNavigate={setCurrentPage} />;
    }
  };

  return (
    <div className="flex flex-col h-full -m-6">
      {/* 상단 네비게이션 */}
      <div className="flex items-center gap-2 px-4 py-3 bg-card border-b border-border">
        {onBack && (
          <button
            onClick={onBack}
            className="p-2 rounded-lg hover:bg-accent"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        )}
        <h1 className="text-xl font-bold mr-6">CRM</h1>

        {/* 탭 메뉴 */}
        <div className="flex items-center gap-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPage === item.id;
            return (
              <button
                key={item.id}
                onClick={() => setCurrentPage(item.id)}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:text-foreground hover:bg-accent'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="hidden sm:inline">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* 페이지 컨텐츠 */}
      <div className="flex-1 overflow-auto p-6">
        {renderPage()}
      </div>
    </div>
  );
}
